..
<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="dispatchData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                          :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="invokeappcode" label="系统编码" prop="invokeappcode">
                    <AppAutoComplete v-if="is_new" ref="invokeappcodeASS" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                    <span v-else>{{dispatchData.invokeappcode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="businesstype" label="业务类型" prop="businesstype">
                     <a-input v-if="is_new" v-model="dispatchData.businesstype" @blur="() => {$refs.businesstype.onFieldBlur();}"/>
                    <span v-else>{{dispatchData.businesstype}}</span>

                </a-form-model-item>

                <a-form-model-item ref="resturl" label="请求地址" prop="resturl">
                     <a-input v-model="dispatchData.resturl" @blur="() => {$refs.resturl.onFieldBlur();}"/>
                </a-form-model-item>
                

                <a-form-model-item ref="requestmode" label="请求方式" prop="requestmode">
                    <a-radio-group v-model="dispatchData.requestmode" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="POST"> POST</a-radio-button>
                        <a-radio-button value="GET"> GET</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="requestformat" label="数据类型" prop="requestformat">
                    <a-radio-group v-model="dispatchData.requestformat" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="xml"> xml</a-radio-button>
                        <a-radio-button value="json"> json</a-radio-button>
                        <a-radio-button value="form"> form</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="outputcharset" label="返回字符集" prop="outputcharset">
                     <a-input v-model="dispatchData.outputcharset" @blur="() => {$refs.outputcharset.onFieldBlur();}"/>
                </a-form-model-item>

                <a-form-model-item ref="requestheaders" label="请求头-json格式" prop="requestheaders">
                     <!-- <a-input v-model="dispatchData.requestheaders" @blur="() => {$refs.requestheaders.onFieldBlur();}"/> -->

                    <editor v-model="dispatchData.requestheaders" @init="editorInit"  theme="monokai" width="100%"
                        height="400" style="font-size:15px;"></editor>
                </a-form-model-item>

                <a-form-model-item ref="remark" label="备注" prop="remark">
                     <a-input v-model="dispatchData.remark" @blur="() => {$refs.remark.onFieldBlur();}"/>
                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
import AppAutoComplete from '@/components/AppAutoComplete'
import Editor from 'vue2-ace-editor'
import {
    check_string_type,
    // string_to_wrap
} from "@/utils/data_format_utils";
const m_title = {
    'adddispatch': '新建业务回调配置',
    'editispatch': '编辑业务回调配置',

};
export default {
    data() {
        return {
            m_title,
            c_title: '',
            labelCol: {span: 6},
            wrapperCol: {span: 10},
            rules: {
                invokeappcode: [
                    {required: true, message: '请选择系统编码', trigger: 'blur'},
                ],
                businesstype: [
                    {required: true, message: '请填写业务类型', trigger: 'blur'},
                ],
                resturl: [
                    {required: true, message: '请填写请求地址', trigger: 'blur'},
                ],
                requestmode: [
                    {required: true, message: '请选择', trigger: 'blur'},
                ],

            },
            confirmLoading: false,
            tLoading: false,
            formItemLayout: 'horizontal',
            dispatchData: {
                invokeappcode:'',//系统编码
                businesstype:'',//业务类型
                resturl:'',//请求地址
                requestmode:'POST',//POST|GET
                requestformat:'',//xml/json/form
                outputcharset:'',//返回字符集
                requestheaders:'',//请求头-json格式
                remark:'',//备注
            },
            is_edit:false,
            is_new:false,
            currentLanguage:'xml',
        };
    },
    components: {
        AppAutoComplete,
        Editor
    },

    methods: {
        editorInit() {
            // require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/xml')
            require('brace/mode/json')
            require('brace/mode/javascript')    //language
            require('brace/mode/less')
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        handleSearchAppcodeChange(value) {
            this.dispatchData.invokeappcode = value;
        },
        handleOk() {
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    console.log(that.dispatchData);
                    // const {params} = this.$route;
                    //编辑
                    this.$store
                        .dispatch({
                            type: that.is_edit ? "open/dispatchUpdate" : "open/dispatchAdd",
                            params: that.dispatchData
                        })
                        .then((response) => {
                            if (response.data.success == '1') {
                                console.log(response)
                                that.handleCancel()
                                that.confirmLoading = false;
                            }
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {
        const {query, params} = this.$route;
        this.c_title = m_title[params.action];

        let that = this;
        that.is_edit = params.action == "editdispatch";
        that.is_new = params.action == "adddispatch"
        if (that.is_edit) {
            that.$store.dispatch({
                type: "open/dispatchQuery",
                params: query
            }).then((res) => {
                console.log(res);
                that.tLoading = false;
                that.dispatchData = res.data.data;
                this.$refs.invokeappcodeASS.setInputVal(that.dispatchData.invokeappcode);
                this.currentLanguage = check_string_type(that.dispatchData.requestheaders);
            })
        }
        else{
            this.$refs.invokeappcodeASS.setInputVal('');
        }
    }
};
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
